import { render, staticRenderFns } from "./GraficoDonut.vue?vue&type=template&id=5252a614&lang=pug"
import script from "./GraficoDonut.vue?vue&type=script&lang=js"
export * from "./GraficoDonut.vue?vue&type=script&lang=js"
import style0 from "./GraficoDonut.vue?vue&type=style&index=0&id=5252a614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports